import { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'next-i18next'

// Context
import { AppContext } from '../../context/AppContext'

// Internal components
import Svg from '../Svg/Svg'
import Loader from '../Loader/Loader'
import { UserContext } from '../../context/UserContext'

const InitialLoader = () => {
  const theme = process.env.NEXT_PUBLIC_THEME
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  // Context
  const appContext = useContext(AppContext)

  // State
  const [loadingState, setLoadingState] = useState(true)

  const changeLoading = () => setLoadingState(false)

  useEffect(() => {
    if (!sessionStorage.getItem('firstTime')) {
      sessionStorage.setItem('firstTime', 'firstRender')
      setTimeout(changeLoading, 2000)
    } else {
      setLoadingState(false)
    }
  }, [])

  return (
    <>
      {!loadingState || appContext?.isNativeApp ? (
        <></>
      ) : (
        <div className="InitialLoader">
          <div className="InitialLoader-wrapper">
            <Svg id={`logo-${theme}--loader`} modifiers={['InitialLoader-logo']} />
          </div>
          <p className="InitialLoader-label">{t('INITIALLOADER__PLATFORM_TITLE')}</p>
          <Loader modifiers={['InitialLoader-loader']} />
        </div>
      )}
    </>
  )
}

export default InitialLoader
